import {FC} from 'react';

import {Trans} from 'react-i18next';

import {Product} from 'types';

import {StyledCustomTags} from './styles';

interface PLPDeliveryInfoProps {
  product: Product;
}

export const PLPDeliveryInfo: FC<PLPDeliveryInfoProps> = ({product}) => {
  const {singleLine} = product?.deliveryDescription ?? {};
  return <Trans i18nKey={singleLine} components={StyledCustomTags} />;
};
